import styled, { keyframes } from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { riotProductSkin } from "./riot-product";
import { LightboxClose } from "../components/LightboxClose";
import { Icon } from "../../Icon";
import { LightboxFrame } from "../components/LightboxFrame";
import { SkinId } from "../../../skins/types";
import { LightboxAspectRatio } from "../components/LightboxAspectRatio";
import { arcaneSkin } from "./arcane";
const fadeInKeyframes = keyframes `
  from { opacity: 0;}
  to { opacity: 1; }
`;
export const themed = (component) => styled(component) `
  & {
    /* Any styles at the top level will be always present and a base for all themes */
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 999999;
    cursor: pointer;
    background-color: rgb(255 255 255 / 70%);
    animation: ${fadeInKeyframes} 0.3s ease-in-out;

    ${LightboxAspectRatio} {
      /* by default, fit LightboxFrame to content. */

      /* when content is in LightboxAspectRatio container, fit LightboxFrame to container. */
      ${LightboxFrame} {
        width: 100%;
        height: 100%;
      }
    }

    /* video content */
    iframe {
      height: 100%;
      width: 100%;
      border: 0 none;
    }

    /* image content in lightbox */
    img {
      object-fit: contain;
    }

    ${LightboxClose} {
      display: block;
      position: absolute;
      top: 10px;
      right: 10px;
      cursor: pointer;

      /* Hack: maybe icons should be the right size? */
      height: 34px;
      width: 34px;
      ${Icon} {
        height: 100%;
        width: 100%;
      }

      @media (width <= 750px) {
        top: 0;
        right: 0;
      }
    }

    .buttons {
      display: flex;
    }

    /*
      This is how we apply theme styles to a component.
      The mixinThemeStyles will decide, based on the current theme, which styles to apply.
      All styles are optional, so you can have a component with only some themes applied.
      These are strongly typed so you can't apply styles to the wrong theme.
    */
    ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
    [SkinId.Arcane]: arcaneSkin,
})}
  }
`;
//# sourceMappingURL=index.js.map